/* eslint-disable react/jsx-filename-extension */
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-app-polyfill/stable";

ReactDOM.render(<App />, document.querySelector("#root"));
